var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54648 3.12424C3.94887 3.12424 3.41309 3.59468 3.41309 4.23691V18.1133C3.41309 19.0311 4.15713 19.7752 5.07496 19.7752H6.90408L6.9082 19.7752V20.7608C6.9082 21.6786 7.65225 22.4227 8.57008 22.4227H18.925C19.8428 22.4227 20.5869 21.6786 20.5869 20.7608V7.75837C20.5869 6.84054 19.8428 6.0965 18.925 6.0965H17.9394V4.78611C17.9394 3.86828 17.1954 3.12424 16.2775 3.12424H4.54648ZM16.6157 6.0965V4.78611C16.6157 4.59937 16.4643 4.44798 16.2775 4.44798H4.73683V18.1133C4.73683 18.3 4.88821 18.4514 5.07496 18.4514H6.90408L6.9082 18.4514V7.75837C6.9082 6.84054 7.65225 6.0965 8.57007 6.0965H16.6157ZM8.23195 7.75837C8.23195 7.57162 8.38333 7.42024 8.57007 7.42024H18.925C19.1117 7.42024 19.2631 7.57163 19.2631 7.75837V20.7608C19.2631 20.9475 19.1117 21.0989 18.925 21.0989H8.57008C8.38333 21.0989 8.23195 20.9475 8.23195 20.7608V7.75837ZM10.4375 12.0533C10.4375 11.6878 10.7338 11.3914 11.0994 11.3914H16.3943C16.7599 11.3914 17.0562 11.6878 17.0562 12.0533C17.0562 12.4189 16.7599 12.7152 16.3943 12.7152H11.0994C10.7338 12.7152 10.4375 12.4189 10.4375 12.0533ZM11.0994 14.9214C10.7338 14.9214 10.4375 15.2178 10.4375 15.5833C10.4375 15.9489 10.7338 16.2452 11.0994 16.2452H16.3943C16.7599 16.2452 17.0562 15.9489 17.0562 15.5833C17.0562 15.2178 16.7599 14.9214 16.3943 14.9214H11.0994Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApply);
export default __webpack_public_path__ + "static/media/icon-apply.71f3445c6c1df552c6cccaa5b527a48e.svg";
export { ForwardRef as ReactComponent };